function slideout_menu(){
  var slideout = new Slideout({
    'panel': document.getElementById('js-so_panel'),
    'menu': document.getElementById('js-so_menu'),
    'duration': 10,
  });
  var nodeList = document.querySelectorAll('#js-so_toggle, #js-so_panel');
  var node = Array.prototype.slice.call(nodeList,0);
  node.forEach(function(elem, index){
    elem.addEventListener('click', function() {
      slideout.toggle();
    });
  });
}


$(function() {
/*********************************************************************
  common
*********************************************************************/
slideout_menu();
$('.js-editor table').each(function(){
  $(this).wrap('<div class="c-tbl_responsive"><div class="rwd_sheet"></div></div>');
});
/*********************************************************************
  index
*********************************************************************/
$('.js-slide').slick({
  autoplay:true,
  autoplaySpeed: 3000,
  speed:900,
  infinite:true,
  slideToScroll:1,
  slidesToShow:1,
  arrows:false,
  dots:true,
  fade: true,
});
$('.js-slide02').slick({
    autoplay:true,
    infinite:true,
    slideToScroll:1,
    slidesToShow:3,
    arrows:true,
    prevArrow: '<img src="./assets/img/common/icon_arrow_bk.png" class="slide-arrow prev-arrow">',
    nextArrow: '<img src="./assets/img/common/icon_arrow_bk.png" class="slide-arrow next-arrow">',
    responsive: [{
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        infinite:false,
       }
    }]
  });


var endDate = new Date($('.js-countdown').attr('data-end'));
var interval = 1000;


function countdownTimer(){
  var nowDate = new Date();
  var period = endDate - nowDate ;
  if(period < 0){
    $('.js-countdown').addClass('is-end');
  }
  var addZero = function(n){return('0'+n).slice(-2);}
  var addZeroDay = function(n){return('0'+n).slice(-3);}
  if(period >= 0) {
  var day = Math.floor(period / (1000 * 60 * 60 * 24));
  period -=  (day　*(1000 * 60 * 60 * 24));
  var hour = Math.floor(period / (1000 * 60 * 60));
  period -= (hour *(1000 * 60 * 60));
  var minutes =  Math.floor(period / (1000 * 60));
  period -= (minutes * (1000 * 60));
  var second = Math.floor(period / 1000);
  $('.js-countdown .count_d').text(addZeroDay(day));
  $('.js-countdown .count_h').text(addZero(hour));
  $('.js-countdown .count_m').text(addZero(minutes));
  $('.js-countdown .count_s').text(addZero(second));
  setTimeout(countdownTimer,10);
  }
}
countdownTimer();
});
$(window).on('load',function(){
});
$(window).on('scroll',function(){
});
$(window).on('resize',function(){
});

